export function Button({ children, onClick, variant = 'default', className = '', ...props }) {
    const variants = {
      default: 'bg-indigo-600 text-white hover:bg-indigo-700',
      outline: 'border border-indigo-600 text-indigo-600 hover:bg-indigo-100',
    }
  
    return (
      <button
        onClick={onClick}
        className={`px-4 py-2 rounded font-medium text-sm ${variants[variant]} ${className}`}
        {...props}
      >
        {children}
      </button>
    )
  }
  